import axios from "axios";
export function apiConfig(params) {
    const defaultTransformResponses = axios.defaults.transformResponse
        ? axios.defaults.transformResponse instanceof Array
            ? axios.defaults.transformResponse
            : [axios.defaults.transformResponse]
        : [];
    return {
        headers: {
            "Content-Type": "application/json",
        },
        params: params !== null && params !== void 0 ? params : {},
        transformResponse: [
            ...defaultTransformResponses,
            (data) => {
                if (data === "")
                    return null;
                return data;
            },
        ],
    };
}
export function authenticatedApiConfig(authenticationProvider, params) {
    const config = apiConfig(params);
    const token = authenticationProvider.token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}
export function generateURL(baseUrl, path, parameters) {
    let fullUrl = baseUrl + path;
    if (parameters) {
        Object.entries(parameters).forEach(([param, value]) => {
            fullUrl = fullUrl.replace(`:${param}`, value.toString());
        });
    }
    return fullUrl;
}
